import   React                            ,
       { useState                         ,
         useEffect                        ,
         useRef                           }  from "react";

import   classNames                          from "classnames";

import   styles                              from "./Subscription.module.scss";

import { Coordinate                       }  from "../../../../dataTypes/geolocationManagment/types"

import { convertDateToString              ,
         convertStringToDate              ,
         roundDate                        }  from '../../../../dataTypes/timeManagment/utils';

import { groupData                        ,
         generateStats                    ,
         generateChartData                ,
         GroupedData                      ,
         ChartData                        ,
         initializedGroupedData           ,
         completeGroupData                }  from "../../../../dataTypes/dataSetManagment/regroupData";

import   CartesianGraph                      from "../../../widget/dataDisplay/charts/CartesianGraph";
import   OpenStreetMap                       from "../../../widget/dataDisplay/maps/OpenStreetMap";
import   ExtendablePanel                     from "../../../widget/windows/ExtendablePanel";
import   Select                              from '../../../widget/inputs/Select';
import   AnimatedWaitingIcon                 from '../../../widget/animations/animatedWaitingIcon';
import   VerticalLabel                       from '../../../widget/dataDisplay/labels/VerticalLabel';
import   Field                               from '../../../widget/inputs/Field';
import   Icon                                from '../../../widget/images/Icon';


import { getEnrichedUsers                 }  from '../../../../backendServices/userManagment/api';

import { User                             ,
         EnrichedUser                     ,
         GetUserListParams                }  from '../../../../dataTypes/userManagment/types';

import { getUserCountByStatus             ,
         getUserStatusChange              ,
         getUserListByStatusChange        ,
         getUserList                      }  from '../../../../backendServices/userManagment/api';


import { useTypedSelector                 }  from '../../../../store/useTypeSelector';
import { RootState                        }  from '../../../../store/generalReducer';



const Subscription: React.FC = () => {

  // Valeur inutilisée, mais l'abonnement est conservé : le retirer changerait
  // la fréquence de rendu du composant.
  useTypedSelector((state: RootState) => state.authenticationReducer);

  const periodNames: string[] = ["Heure glissante", "Jour courant", "Semaine courante", "Mois courant", "Personnaliser"]

  const now = new Date();

  // 1 heure glissante 
  const rollingHourStart   = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() -1, 0, 0);

  // 7 jours glissants (le jour courant étant le dernier jour)
  const rollingWeekStart   = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6, 0, 0, 0);

  // Mois courant
  const currentDayStart    = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);

  // Mois courant
  const currentMonthStart  = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);

  // Mois précédent

  // Année courante (du 1er janvier jusqu'à aujourd'hui)

  // Année précédente (du 1er janvier au 31 décembre)

  // ~~~~~~ Calcul hauteur
  
  let   userChartDimensions = ({ width: 0, height: 0 });
  
  const userChartRef        = useRef<HTMLDivElement>(null);

  const updateUserChartDimensions = () => {
  
    if (userChartRef.current)  
	 {
	  if ( userChartDimensions.width === 0 || userChartDimensions.height === 0 )
	   {
        const { width, height } = userChartRef.current.getBoundingClientRect();
        userChartDimensions = ({ width, height });
	   }
     }
  };	

  useEffect(() => {
  
    const resizeObserver = new ResizeObserver(() => {
		
	  updateUserChartDimensions()
    });

    if (userChartRef.current) 
	 {
      resizeObserver.observe(userChartRef.current);
     }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  // ~~~~~~ Variables

  const [ selectedSubscriptionPeriod                , setSelectedSubscriptionPeriod                ] = useState (periodNames[3])
  const [            , setSelectedSubscriptionPeriodIndex           ] = useState (3)
  const [ subscriptionPeriodStartDate               , setSubscriptionPeriodStartDate               ] = useState<Date> ( currentMonthStart );
  const [ subscriptionPeriodEndDate                 , setSubscriptionPeriodEndDate                 ] = useState<Date> ( now );

  const [ userList                                  , setUserList                                  ] = useState<EnrichedUser[]>([]);
  const [ userCreationPeriodTimeStep                , setUserCreationPeriodTimeStep                ] = useState ('1 jour')
  const [                 , setSelectedUserCreationPeriod                ] = useState (periodNames[3])
  const [ selectedUserCreationPeriodIndex           , setSelectedUserCreationPeriodIndex           ] = useState (3)
  const [                    , setUserCreationGroupedData                   ] = useState<GroupedData<EnrichedUser>>(initializedGroupedData<EnrichedUser>())
  const [ userCreationChartData                     , setUserCreationChartData                     ] = useState<ChartData[]>([])
  const [ userCreationCoordinates                   , setUserCreationCoordinates                   ] = useState<Coordinate[]>([]);
  const [ userCreationPeriodStartDate               , setUserCreationPeriodStartDate               ] = useState<Date> ( currentMonthStart );
  const [ userCreationPeriodEndDate                 , setUserCreationPeriodEndDate                 ] = useState<Date> ( now   );
 
  const [                          , setSubscriptionCount                         ] = useState (0)
  const [ discoverSubscriptionCount                 , setDiscoverSubscriptionCount                 ] = useState (0)
  const [ standardSubscriptionCount                 , setStandardSubscriptionCount                 ] = useState (0)
  const [ premiumSubscriptionCount                  , setPremiumSubscriptionCount                  ] = useState (0)
  const [                 , setSubscriptionCount_arrivals                ] = useState (0)
  const [ discoverSubscriptionCount_arrivals        , setDiscoverSubscriptionCount_arrivals        ] = useState (0)
  const [ standardSubscriptionCount_arrivals        , setStandardSubscriptionCount_arrivals        ] = useState (0)
  const [ premiumSubscriptionCount_arrivals         , setPremiumSubscriptionCount_arrivals         ] = useState (0)
  const [               , setSubscriptionCount_departures              ] = useState (0)
  const [ discoverSubscriptionCount_departures      , setDiscoverSubscriptionCount_departures      ] = useState (0)
  const [ standardSubscriptionCount_departures      , setStandardSubscriptionCount_departures      ] = useState (0)
  const [ premiumSubscriptionCount_departures       , setPremiumSubscriptionCount_departures       ] = useState (0)

  const [ showWaitingIcon_UserCreationInformations  , setShowWaitingIcon_UserCreationInformations  ] = useState(false);
  const [ showWaitingIcon_UserCountByStatus         , setShowWaitingIcon_UserCountByStatus         ] = useState(false);
  const [ showWaitingIcon_UserArrivalsAndDepartures , setShowWaitingIcon_UserArrivalsAndDepartures ] = useState(false);

  // ~~~~~~ Fetch data functions

  const fetchUserCreationInformations = async () => {
	  
    try 
	 {
      setShowWaitingIcon_UserCreationInformations(true);
	  
      const userCreationParams: GetUserListParams = {
          beginningDate: userCreationPeriodStartDate,
          endingDate: userCreationPeriodEndDate
      };

      const usersResult = await getEnrichedUsers(userCreationParams);

      if (usersResult.code === 1) 
       {
        setUserList(usersResult.payload);
       }
     } 
	catch (error) 
	 {
      console.error("Erreur lors de la récupération des sessions :", error);
      setShowWaitingIcon_UserCreationInformations(false);
     }
  };

  const fetchUserCountByStatus = async () => {
	  
    try 
     {
      setShowWaitingIcon_UserCountByStatus (true);

      const [ getUserCountByStatusDiscoverReponse ,
              getUserCountByStatusStandardReponse ,
              getUserCountByStatusPremiumReponse  ] = await Promise.all([ getUserCountByStatus ('Discover') ,
                                                                          getUserCountByStatus ('Standard') ,
                                                                          getUserCountByStatus ('Premium' ) ]);

      const da = getUserCountByStatusDiscoverReponse.code === 1 ? getUserCountByStatusDiscoverReponse.payload : 0;
      const sa = getUserCountByStatusStandardReponse.code === 1 ? getUserCountByStatusStandardReponse.payload : 0;
      const pa = getUserCountByStatusPremiumReponse.code  === 1 ? getUserCountByStatusPremiumReponse.payload  : 0;
      const a = da + sa + pa;

      setSubscriptionCount(a);
      setDiscoverSubscriptionCount(da);
      setStandardSubscriptionCount(sa);
      setPremiumSubscriptionCount(pa);
     } 
	catch (error) 
	 {
      console.error("Erreur lors de la récupération des informations :", error);
     }
	 
    setShowWaitingIcon_UserCountByStatus(false);
  };

  const fetchUserArrivalsAndDepartures = async () => {
	  
    try 
	 {
      setShowWaitingIcon_UserArrivalsAndDepartures (true);

      const userCreationParams: GetUserListParams = {
        beginningDate: subscriptionPeriodStartDate,
        endingDate: subscriptionPeriodEndDate
      };

      const [
        getEnrichedUsers_response,
        getUserStatusChange_da_response,
        getUserStatusChange_sa_response,
        getUserStatusChange_pa_response,
        getUserStatusChange_dd_response,
        getUserStatusChange_sd_response,
        getUserStatusChange_pd_response
      ] = await Promise.all([
        getEnrichedUsers(userCreationParams),
        getUserStatusChange('Discover', subscriptionPeriodStartDate, subscriptionPeriodEndDate, 'Creation'),
        getUserStatusChange('Standard', subscriptionPeriodStartDate, subscriptionPeriodEndDate, 'Creation'),
        getUserStatusChange('Premium', subscriptionPeriodStartDate, subscriptionPeriodEndDate, 'Creation'),
        getUserStatusChange('Discover', subscriptionPeriodStartDate, subscriptionPeriodEndDate, 'Closure'),
        getUserStatusChange('Standard', subscriptionPeriodStartDate, subscriptionPeriodEndDate, 'Closure'),
        getUserStatusChange('Premium', subscriptionPeriodStartDate, subscriptionPeriodEndDate, 'Closure')
      ]);

      if (getEnrichedUsers_response.code === 1) {
        const coords = getEnrichedUsers_response.payload.map(user => ({
          lat: user.ipApiCom_lat ?? 0,
          lng: user.ipApiCom_lon ?? 0,
          info1: `${convertDateToString (user.creationDate, 'dd/MM/yyyy HH:mm:ss') || "N/A"} ${ (user.status === 'Discover' ? 'Dévouverte' : user.status) || "N/A"}`,
          info2: `${user.firstname || "N/A"} ${user.lastname || "N/A"}`,
          color: `${user.status==='Premium' ? 'redP' : (user.status==='Standard' ? 'blue' : 'violet')}` 
        }));

        setUserCreationCoordinates(coords);
      }

      const da = getUserStatusChange_da_response.code === 1 ? getUserStatusChange_da_response.payload : 0;
      const sa = getUserStatusChange_sa_response.code === 1 ? getUserStatusChange_sa_response.payload : 0;
      const pa = getUserStatusChange_pa_response.code === 1 ? getUserStatusChange_pa_response.payload : 0;
      const a = da + sa + pa;

      const dd = getUserStatusChange_dd_response.code === 1 ? getUserStatusChange_dd_response.payload : 0;
      const sd = getUserStatusChange_sd_response.code === 1 ? getUserStatusChange_sd_response.payload : 0;
      const pd = getUserStatusChange_pd_response.code === 1 ? getUserStatusChange_pd_response.payload : 0;
      const d = dd + sd + pd;

      setSubscriptionCount_arrivals(a);
      setDiscoverSubscriptionCount_arrivals(da);
      setStandardSubscriptionCount_arrivals(sa);
      setPremiumSubscriptionCount_arrivals(pa);

      setSubscriptionCount_departures(d);
      setDiscoverSubscriptionCount_departures(dd);
      setStandardSubscriptionCount_departures(sd);
      setPremiumSubscriptionCount_departures(pd);
     } 
	catch (error) 
	 {
      console.error("Erreur lors de la récupération des sessions :", error);
     }
	 
    setShowWaitingIcon_UserArrivalsAndDepartures(false);
  };

  const fetchSubscriptions = async () => {
	fetchUserCountByStatus ()
	fetchUserArrivalsAndDepartures ()
  };

  // ~~~~~~ Timers

  const intervalRef_UserCreation  = useRef<NodeJS.Timeout | null>(null);
  const intervalRef_Subscription  = useRef<NodeJS.Timeout | null>(null);
    
  useEffect(() => {
    
    fetchUserCreationInformations(); // Appel initial

    intervalRef_UserCreation.current = setInterval(fetchUserCreationInformations, 60000); // 60000 milliseconds = 1 minute

    return () => {
      if (intervalRef_UserCreation.current) {
        clearInterval(intervalRef_UserCreation.current); // Nettoyage de l'intervalle lors du démontage du composant
      }
    };
  }, [ userCreationPeriodStartDate, userCreationPeriodEndDate ]);
    
  useEffect(() => {
    
    fetchSubscriptions(); // Appel initial

    intervalRef_Subscription.current = setInterval(fetchSubscriptions, 60000); // 60000 milliseconds = 1 minute

    return () => {
      if (intervalRef_Subscription.current) {
        clearInterval(intervalRef_Subscription.current); // Nettoyage de l'intervalle lors du démontage du composant
      }
    };
  }, [ subscriptionPeriodStartDate , subscriptionPeriodEndDate ]);

  // ~~~~~~ group functions

  const getGroupKeyUserCreation = (timeStep: string) => {
      
    switch (timeStep)
     {
      case "1 minute"   : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "mm", 1), "yyyy/MM/dd HH:mm")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "HH:mm")}`
                                                 });

      case "5 minutes"  : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "mm", 5), "yyyy/MM/dd HH:mm")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "HH:mm")}`
                                                 });

      case "10 minutes" : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "mm", 10), "yyyy/MM/dd HH:mm")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "HH:mm")}`
                                                 });

      case "1 heure"    : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "HH", 1), "yyyy/MM/dd HH")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                 });

      case "6 heures"   : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "HH", 6), "yyyy/MM/dd HH")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                 });

      case "12 heures"  : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "HH", 12), "yyyy/MM/dd HH")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                 });

      case "1 jour"     : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "dd", 1), "yyyy/MM/dd")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                 });

      case "1 semaine"  : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "dd", 7), "yyyy/MM/dd")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                 });

      case "2 semaines" : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "dd", 14), "yyyy/MM/dd")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                 });

      case "1 mois"     : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "MM", 1), "yyyy/MM")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM"), "MM/yyyy")}`,
                                                 });

      case "6 mois"     : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "MM", 6), "yyyy/MM")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM"), "MM/yyyy")}`,
                                                 });

      case "1 an"       : return (user: User) => ({
                                                    key      : `${convertDateToString(roundDate (user.creationDate!, "yyyy", 1), "yyyy")}`,
                                                    renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy"), "yyyy")}`,
                                                 });

      default           : throw new Error(`Unsupported timeStep: ${timeStep}`);
     }
  };

  // ~~~~~~ useEffect
  
  useEffect(() => {
      
    const groupedData = groupData<User>(userList, getGroupKeyUserCreation (userCreationPeriodTimeStep));

    const completedGroupData = completeGroupData<User>(groupedData, userCreationPeriodTimeStep, userCreationPeriodStartDate, userCreationPeriodEndDate);

    setUserCreationGroupedData(completedGroupData);

    const statsResult = generateStats<User>(completedGroupData, () => 1, (a, b) => a + b);

    const chartData = generateChartData<User>(statsResult, completedGroupData);
    
    setUserCreationChartData(chartData);
	
	setShowWaitingIcon_UserCreationInformations (false);

  }, [userList, userCreationPeriodTimeStep]);


  // ~~~~~~ Handles to specify period

  const handleSubscriptionPeriodChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
	  
    console.log ( 'handleSubscriptionPeriodChange', e.target.selectedIndex-1)
	  
	  
    setSelectedSubscriptionPeriod      (e.target.value);
    setSelectedSubscriptionPeriodIndex (e.target.selectedIndex-1);
    setSelectedUserCreationPeriod      (e.target.value);
    setSelectedUserCreationPeriodIndex (e.target.selectedIndex-1);

    switch ( e.target.selectedIndex-1 )
     {
      case 0 : // Heure glissante

               setSubscriptionPeriodStartDate     (rollingHourStart);
               setSubscriptionPeriodEndDate       (now);
               
               setUserCreationPeriodStartDate     (rollingHourStart);
               setUserCreationPeriodEndDate       (now);
               setUserCreationPeriodTimeStep      ('1 minute');
               break;
         
      case 1 : // Jour courant

               setSubscriptionPeriodStartDate     (currentDayStart);
               setSubscriptionPeriodEndDate       (now);
               
               setUserCreationPeriodStartDate     (currentDayStart);
               setUserCreationPeriodEndDate       (now);
               setUserCreationPeriodTimeStep      ('1 heure');

               break;
               
      case 2 : // Semaine courante

               setSubscriptionPeriodStartDate     (rollingWeekStart);
               setSubscriptionPeriodEndDate       (now);
               
               setUserCreationPeriodStartDate     (rollingWeekStart);
               setUserCreationPeriodEndDate       (now);
               setUserCreationPeriodTimeStep      ('1 jour');

               break;

      case 3 : // Mois courant

               setSubscriptionPeriodStartDate     (currentMonthStart);
               setSubscriptionPeriodEndDate       (now);
               
               setUserCreationPeriodStartDate     (currentMonthStart);
               setUserCreationPeriodEndDate       (now);
               setUserCreationPeriodTimeStep      ('1 jour');

               break;
     }
  };

  const handleSubscriptionPeriodStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value;
    const convertedDate = convertStringToDate(newDate, "dd/MM/yyyy")

    if (convertedDate)
          {
           setSubscriptionPeriodStartDate(convertedDate);
           setUserCreationPeriodStartDate(convertedDate);
          }
     else {
           console.error("Invalid date format received");
          }
  }

  const handleSubscriptionPeriodEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value;
    const convertedDate = convertStringToDate(newDate, "dd/MM/yyyy");

    if (convertedDate)
          {
           setSubscriptionPeriodEndDate(convertedDate);
           setUserCreationPeriodEndDate(convertedDate);           
          }
     else {
           console.error("Invalid date format received");
          }
  }

  // ~~~~~~ Subscriptions table and chart

const [ showSubscriberInfo     , setShowSubscriberInfo     ] = useState(false);
const [ SubscriberInfoPosition , setSubscriberInfoPosition ] = useState({ top: 0, left: 0 });
const [ SubscriberInfoContent  , setSubscriberInfoContent  ] = useState<string[]>([]);


const fetchUserListByStatusChange = async ( status     : string ,
                                            changeType : string ): Promise<boolean> => {

  const result = await getUserListByStatusChange (status, subscriptionPeriodStartDate, subscriptionPeriodEndDate, changeType)


  let temp: string[] = [];

  if ( result.code === 1 )
   {

    for (const item of result.payload) 
	 {
      let date = "";

           if ( changeType === "Closure"  ) { date = item.closureDate  ? item.closureDate.toLocaleDateString()  : ''; } 
      else if ( changeType === "Creation" ) { date = item.creationDate ? item.creationDate.toLocaleDateString() : ''; }

      const id     = item.id;
      const prenom = item.firstname; // correction ici
      const nom    = item.lastname;

      temp.push(`${date}: ${prenom} ${nom} (id:${id})`);
    }

    setSubscriberInfoContent(temp);
   }

 return temp.length>0
}

const fetchUserListByStatus = async ( status : string ) : Promise<boolean> => {

  const userCreationParams: GetUserListParams = {
          status: status
      };


  const result = await getUserList (userCreationParams)


  let temp: string[] = [];

  if ( result.code === 1 )
   {
    for (const item of result.payload)
	 {
      let date = item.creationDate ? item.creationDate.toLocaleDateString() : '';

      const id     = item.id;
      const prenom = item.firstname; // correction ici
      const nom    = item.lastname;

      temp.push(`${date}: ${prenom} ${nom} (id:${id})`);
    }

    setSubscriberInfoContent(temp);
   }

 return temp.length>0
}

const handleMouseEnter = async (
  event: React.MouseEvent,
  groupName?: string,
  seriesName?: string,
  value?: number
) => {

  const x = event.clientX;
  const y = event.clientY;
  const shift = document.documentElement.scrollHeight - window.innerHeight - window.scrollY

  if ( value && value > 0 )
   {
    setSubscriberInfoPosition({ top: y -shift - 40, left: x - 180});

    const groupNameBis  = ( groupName  === 'Découverte' ? 'Discover' : groupName)
    const seriesNameBis = ( seriesName === 'arrivals'   ? 'Creation' : (seriesName === 'departures' ? 'Closure' : ''))

    const result = await fetchUserListByStatusChange ( groupNameBis ?? '' , seriesNameBis ?? '' )


    setShowSubscriberInfo(result);
   }
};

const handleMouseEnter2 = async (
  event: React.MouseEvent,
  groupName?: string,
  value?: number) => {

  const x = event.clientX;
  const y = event.clientY;
  const shift = document.documentElement.scrollHeight - window.innerHeight - window.scrollY

  if ( value && value > 0 )
   {
    setSubscriberInfoPosition({ top: y -shift - 40, left: x - 180});

    if ( groupName && groupName  !== 'Découverte' )
     {
      const result = await fetchUserListByStatus ( groupName as string )


      setShowSubscriberInfo(result);
     }

   }
};

const handleMouseLeave = () => {
  setShowSubscriberInfo(false);
    setSubscriberInfoContent([]);
};

  
  const renderLittleTable = ( val1: number, val2: number , groupName: string) => {

    return <div className={classNames(styles.littleTable)}>
             <div className={classNames(styles.littleTable_departure)}>
               <Icon name         = "arrowUp"
                     color        = "var(--color-G)"
                     width        = {20}
                     height       = {16}
                     hoverable    = {false}
                     clickable    = {false}
                     onMouseEnter = {(e) => handleMouseEnter(e, groupName, 'arrivals', val1)}
                     onMouseLeave = {handleMouseLeave} />
               <span className={classNames(styles.littleTable_text)}>{val1}</span>
             </div>
             <div className={classNames(styles.littleTable_arrival)}>
               <Icon name         = "arrowDown"
                     color        = "var(--color-R)"
                     width        = {20}
                     height       = {16}
                     hoverable    = {false}
                     clickable    = {false}
                     onMouseEnter = {(e) => handleMouseEnter(e, groupName, 'departures', val1)}
                     onMouseLeave = {handleMouseLeave}/>
               <span className={classNames(styles.littleTable_text)}>{val2}</span>
             </div>
           </div>

  }

  const getSubscriptionsSummaryChartSubTitle = () => {

    let subTitle = selectedSubscriptionPeriod

    if ( selectedSubscriptionPeriod === 'Personnaliser' )
     {
      subTitle = `Du ${convertDateToString(subscriptionPeriodStartDate, "dd/MM/yyyy")} au ${convertDateToString(subscriptionPeriodEndDate, "dd/MM/yyyy")}`
     }

    return subTitle
  }

  const renderSubscriptionsSummary = () : JSX.Element => {

    const subscriptionsSummaryChartData: ChartData[] = [
      {
        group: "Découverte",
        series: [
                 {
                  name  : 'arrivals',
                  value : discoverSubscriptionCount_arrivals
                 },
                 {
                  name  : 'departures',
                  value : discoverSubscriptionCount_departures
                 }
                ]
      },
      {
        group: "Standard",
        series: [
                 {
                  name  : 'arrivals',
                  value : standardSubscriptionCount_arrivals
                 },
                 {
                  name  : 'departures',
                  value : standardSubscriptionCount_departures
                 }
                ]
      },
      {
        group: "Premium",
        series: [
                 {
                  name  : 'arrivals',
                  value : premiumSubscriptionCount_arrivals
                 },
                 {
                  name  : 'departures',
                  value : premiumSubscriptionCount_departures
                 }
                ]
      },
    ]

    return <>
	
              <div className={classNames(styles.subscriptionsSummary_line0)}>

                <VerticalLabel label      = {<>Découverte</>}
                               value      = {discoverSubscriptionCount}
                               width      = "15%"
                               sizeLabel  = {23}
                               sizeValue  = {30}
                               colorValue = "var(--color-Text-FG-emphasized)" />

                <VerticalLabel label      = {<>Standard</>}
                               value      = {standardSubscriptionCount}
                               width      = "15%"
                               sizeLabel  = {23}
                               sizeValue  = {30}
                               colorValue = "var(--color-Text-FG-emphasized)"
                                 onMouseEnter = {(e) => handleMouseEnter2 (e, 'Standard', standardSubscriptionCount)}
                                 onMouseLeave = {handleMouseLeave} />

                <VerticalLabel label      = {<>Premium</>}
                               value      = {premiumSubscriptionCount}
                               width      = "15%"
                               sizeLabel  = {23}
                               sizeValue  = {30}
                               colorValue = "var(--color-Text-FG-emphasized)"
                                 onMouseEnter = {(e) => handleMouseEnter2 (e, 'Premium', premiumSubscriptionCount)}
                                 onMouseLeave = {handleMouseLeave} />
              </div>

              <div className={classNames(styles.subscriptionsSummary_line1)}>

                <Select choices  = {periodNames}
                        value    = {selectedSubscriptionPeriod}
                        onChange = {handleSubscriptionPeriodChange} />
              
  			    {
                 selectedSubscriptionPeriod === periodNames[4] &&
				 (
                  <div className={classNames(styles.subscriptionsSummary_customPeriodeChoice)}>
                    <Field value     = {subscriptionPeriodStartDate ? convertDateToString (subscriptionPeriodStartDate, "dd/MM/yyyy") : ''}
                           onChange  = {handleSubscriptionPeriodStartDateChange}
                           type      = "calendar"  />
                    <Field value     = {subscriptionPeriodEndDate ? convertDateToString (subscriptionPeriodEndDate, "dd/MM/yyyy") : ''}
                           onChange  = {handleSubscriptionPeriodEndDateChange}
                           type      = "calendar"  />
                  </div>
				 )
                }
              </div>

              <div className={classNames(styles.subscriptionsSummary_line2)}>

                <div className={classNames(styles.elementContainer)}>

                  <VerticalLabel label        = {<>Découverte</>}
                                 value        = {renderLittleTable(discoverSubscriptionCount_arrivals, discoverSubscriptionCount_departures, 'Discover')}
                                 width        = "100%"
                                 sizeLabel    = {12}
                                 sizeValue    = {30}
                                 colorValue   = "var(--color-Text-FG-emphasized)"/>

                  <VerticalLabel label        = {<>Standard</>}
                                 value        = {renderLittleTable(standardSubscriptionCount_arrivals, standardSubscriptionCount_departures, 'Standard')}
                                 width        = "100%"
                                 sizeLabel    =  {12}
                                 sizeValue    = {30}
                                 colorValue   = "var(--color-Text-FG-emphasized)" />


                  <VerticalLabel label        = {<>Premium</>}
                                 value        = {renderLittleTable(premiumSubscriptionCount_arrivals, premiumSubscriptionCount_departures, 'Premium')}
                                 width        = "100%"
                                 sizeLabel    = {12}
                                 sizeValue    = {30}
                                 colorValue   = "var(--color-Text-FG-emphasized)" />
                </div>

                <div className={classNames(styles.subscribersBarGraph)}>
                  <ExtendablePanel logoUrl = "/images/logo.png"  >
                    <CartesianGraph data               = {subscriptionsSummaryChartData}
                                    title              = "Inscriptions et désinscriptions"
                                    subTitle           = {getSubscriptionsSummaryChartSubTitle()}
                                    colors             = {["var(--color-G)","var(--color-R)"]}
                                    titleFontSize      = {24}
                                    subTitleFontSize   = {21}
                                    xAxisLabelFontSize = {15}
                                    yAxisLabelFontSize = {15}
                                    paddingTop         = {110}  
                                    paddingBottom      = {50}
                                    paddingLeft        = {30}
                                    width              = {542}
                                    height             = {278}
                                    cumul              = {false}
                                    showLegend         = {false}
                                    grapheType         = 'Bar'
                                    onMouseEnter       = {handleMouseEnter}
                                    onMouseLeave       = {handleMouseLeave}/>
                  </ExtendablePanel>
                </div>
              </div>

            </>
  }

  // ~~~~~~ User creation chart

  const generateBarGraphTitle = () : string => {

    return `Nombre de comptes créés`
  }

  const generateBarGraphSubTitle = () : string => {

    const date1 = convertDateToString (userCreationPeriodStartDate ,'dd/MM/yyyy')
    const date2 = convertDateToString (userCreationPeriodEndDate   ,'dd/MM/yyyy')

    const samplePeriod = ( selectedUserCreationPeriodIndex === 0 || selectedUserCreationPeriodIndex === 1 ) ? "jour" : "mois"

    return `Du ${date1} au ${date2}, par ${samplePeriod}`
  }

  const renderUserCreationChart = () : JSX.Element => {

	const height = 455 / 921 * window.innerHeight

    return  <ExtendablePanel logoUrl = "/images/logo.png" height={height} >
               <CartesianGraph data               = {userCreationChartData}
                               title              = {generateBarGraphTitle()}
                               subTitle           = {generateBarGraphSubTitle()}
                               titleFontSize      = {24}
                               subTitleFontSize   = {21}
                               xAxisLabelFontSize = {15}
                               yAxisLabelFontSize = {15}
                               paddingTop         = {120}
                               paddingBottom      = {100}
                               paddingLeft        = {100}                         
                               showLegend         = {false}
                               grapheType         = 'Bar' />
            </ExtendablePanel>

  }

  // ~~~~~~ User creation map

  const renderUserCreationMap = () : JSX.Element => {

    return <ExtendablePanel logoUrl="/images/logo.png" logoPosition="bottomLeft">
              <OpenStreetMap coordinates={userCreationCoordinates} initialZoom={4}/>
           </ExtendablePanel>
  }

  return (
  
    <div className={classNames(styles.root)}>

{showSubscriberInfo && (
  <div
    className={styles.tooltip}
    style={{
      position: 'absolute',
      top: SubscriberInfoPosition.top,
      left: SubscriberInfoPosition.left,
      background: 'white',
      border: '1px solid black',
      padding: '4px 8px',
      fontSize: '12px',
      pointerEvents: 'none',
      zIndex: 1000,
    }}
  >
    {SubscriberInfoContent.map((line, index) => (
      <div key={index} style={{color: 'black'}}>{line}</div>
    ))}
  </div>
)}

      <div className={classNames(styles.subscriptionsSummary)}>
	  
        <div className={classNames(styles.overlay)}>
		  {showWaitingIcon_UserArrivalsAndDepartures && 
		   showWaitingIcon_UserCountByStatus         && <AnimatedWaitingIcon />}
        </div>

        {renderSubscriptionsSummary()}
      </div>
        
      <div ref={userChartRef} className={classNames(styles.userChart)}>
	  
        <div className={classNames(styles.overlay)}>
		  {showWaitingIcon_UserCreationInformations && <AnimatedWaitingIcon />}
        </div>

        {renderUserCreationChart()}
      </div>        
        
      <div className={classNames(styles.summaryMap)}>
	  
        <div className={classNames(styles.overlay)}>
		  {showWaitingIcon_UserCreationInformations && <AnimatedWaitingIcon />}
        </div>
		
        {renderUserCreationMap()}
      </div>        
      
    </div>
  );

};

export default Subscription;
